import {
    GET_ALL_CHATS,
} from '../actions/types';

const initialState = {
    chats: {},
    selectedChat: {},
    loading: true,
    error: {}
};

function chatReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_ALL_CHATS:
            return {
                ...state,
                chats: payload,
                loading: false
            };
        default:
            return state;
    }
}

export default chatReducer;
